import { KeyboardEvent, useState } from "react";
import { useRouter } from "next/router";
import { useAtomValue, useStore } from "jotai";
import { HelpSearchAtom } from "@models/state";

interface Params {
  path?: string;
}

export function useHelpSearch(params?: Params) {
  const router = useRouter();
  const store = useStore();
  const term = useAtomValue(HelpSearchAtom);
  const [value, setValue] = useState(term);

  const onSearch = (e: KeyboardEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;

    if (e.key === "Enter" && params?.path) {
      store.set(HelpSearchAtom, target.value);
      router.push(params.path);
    }
  }

  const clearSearch = () => {
    store.set(HelpSearchAtom, "");
  }

  return {
    models: {
      value,
      term,
    },
    operations: {
      setValue,
      onSearch,
      clearSearch
    },
  }
}
